<template>
    <div class='tab-content'>
        <div class='preview'>
            <div class='title'>
                <span>{{ centerName }}</span>
            </div>

            <div class='cover'>
                <img :src="config.coverImageUrl"  v-if='config.coverImageUrl' />
            </div>

            <div class='headline'>
                <span>{{ config.headline }}</span>
            </div>

            <div class='subtitle'>
                <span>{{ config.subtitle }}</span>
            </div>
        </div>

        <div class='settings-container'>
            <div class="line">
                <span class="tit">
                    대표 이미지
                    <div class="com-tooltip">
                        <button class="icon"></button>
                        <div class="detail">
                            <span class="tit">대표 이미지</span>
                            <p class="txt">
                                권장 사이즈 1234x234 용량600kb 이하
                            </p>
                        </div>
                    </div>
                </span>

                <div class="cover mt-4" @click='onCoverImagePicker'>
                    <b-form-file
                        ref='coverImageInput'
                        id="file1"
                        accept=".jpg, .png, .gif"
                        plain
                        @change="onChangeCoverImage"
                        hidden
                    />

                    <img :src="config.coverImageUrl" alt="사진" v-if='config.coverImageUrl' />
                    <div v-else style='text-align: center; align-self: center'>
                        <img src="/img/icons/ic_big_plus.png" style="width: 20px" />
                        <div class="add-title" style="font-size: 14px; font-weight: 500; color: #808080; margin-top: 8px">이미지 추가</div>
                    </div>

                    <button v-if='config.coverImageUrl' class='com-btn red' style='position: absolute; right: 8px; top: 8px;' @click.stop="onDeleteCoverImage">
                        삭제
                    </button>
                </div>
            </div>

            <div class="line">
                <span class="tit">
                    대표 문구<span class="imp">*</span>
                </span>

                <div class="mt-4">
                    <input v-model="config.headline" class="w800" required type="text" maxlength='255' />
                </div>

                <div class='mt-4'>
                    <input v-model="config.subtitle" class="w800" required type="text" maxlength='255' />
                </div>
            </div>

            <div class="line">
                <span class="tit">
                    회원이용약관<span class="imp">*</span>
                </span>

                <div class="mt-4">
                    <textarea v-model="config.termsService" class="w800" rows="12" required></textarea>
                </div>
            </div>

            <div class="bottom-btn">
                <button :disabled="isLoading" class="com-btn" type="submit" @click="onCancel">취소</button>
                <button :disabled="isLoading" class="com-btn blue" type="submit" @click="onSubmit">저장</button>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from 'vuex';

import api from '@/assets/js/api';

export default {
    name: 'HomeScreen',

    data() {
        return {
            isLoading: false,

            centerName: '',

            config: {
                headline: '',
                subtitle: '',
                coverImageUrl: '',
                coverImage: {
                    filename: '',
                    mimetype: '',
                    base64data: '',
                },
                termsService: '',
            }
        }
    },

    computed: {
        ...mapState({
            centerId: (state) => state.auth.user.centerId,
        }),
    },

    mounted() {
        this.getCenter();
        this.getKioskSetting();
    },

    methods: {
        async getCenter() {
            const { data } = await api.get(`/admin/api/center/${this.centerId}`);

            this.centerName = data.centerName;
        },

        async getKioskSetting() {
            this.isLoading = true;

            try {
                const { data } = await api.get(`/admin/api/center/${this.centerId}/kiosk/config`);

                Object.assign(this.config, data);
            } catch (e) {
                alert('로딩에 실패하였습니다.');
            }

            this.isLoading = false;
        },

        onCoverImagePicker() {
            this.$refs.coverImageInput.$refs.input.click();
        },

        onChangeCoverImage(e) {
            const file = e.target.files[0];
            this.config.coverImage = {
                filename: file.name,
                mimetype: file.type
            }

            const reader = new FileReader();
            reader.onload = (e) => {
                this.config.coverImageUrl = e.target.result;
                this.config.coverImage.base64data = this.config.coverImageUrl.split(',')[1];
            };
            reader.readAsDataURL(file);

            this.$refs.coverImageInput.reset();
        },

        onDeleteCoverImage(e) {
            this.config.coverImageUrl = null;
            this.config.coverImage = {};
        },

        async onCancel() {
            await this.getKioskSetting();
        },

        async onSubmit() {
            this.isLoading = true;

            const params = { ...this.config };
            if (params.coverImageUrl && !params.coverImageUrl.startsWith('http')) {
                delete params.coverImageUrl;
            }
            if (!params.coverImage.filename) {
                delete params.coverImage;
            }

            try {
                await api.post(`/admin/api/center/${this.centerId}/kiosk/config`, params);

                alert('저장했습니다.');
            } catch (e) {
                console.error(e);
                alert('저장에 실패했습니다.');
            }

            this.isLoading = false;
        }
    }
}
</script>

<style scoped>
.preview {
    position: relative;
    width: 570px;
    height: 942px;
    padding-left: 25px;
    padding-right: 25px;
    background: url('/img/kiosk_view.png') no-repeat;
}

.preview .cover {
    position: absolute;
    width: 476px;
    height: 318px;
    top: 101px;
    left: 50%;
    transform: translateX(-50%);
}

.preview .title {
    position: absolute;
    top: 60px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.title span {
    font-size: 20px;
    font-weight: 500;
    color: white;
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
}


.preview .headline {
    position: absolute;
    top: 447px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.headline span {
    font-size: 20px;
    font-weight: 500;
    color: #111827;
    max-width: 60%;
    white-space: nowrap;
    overflow: hidden;
}

.preview .subtitle {
    position: absolute;
    top: 486px;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
}

.subtitle span {
    display: inline-block;
    font-size: 16px;
    color: #6B7280;
    text-align: center;
    max-width: 60%;
    white-space: normal;
    word-break: break-word;
}

.settings-container {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding-left: 40px;
    padding-right: 40px;
}

.line {
    margin-top: 24px;
}

.line .cover {
    display: flex;
    position: relative;
    width: 360px;
    height: 212px;
    border: 1px solid #E1E1E1;
    justify-content: center;
}

.cover > img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}

.tit {
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    color: $table-sub-title-color;
}

textarea {
    padding-left: 8px;
    padding-right: 8px;
    border: 1px solid #ced4da;
    border-radius: 4px;
    font-size: 14px;
    color: #707070;
}

</style>